<template>
  <div class="wrapper">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'GuestLayoutComponent',
  components:{
  },
  mounted(){
    document.body.classList.remove('layout-1');
  },
}
</script>